<template>
  <vs-popup class="add-user-types" id="popup" :title="isCreateMode ? 'ADD DEFAULT MARGIN' : 'UPDATE DEFAULT MARGIN'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-margin-cost-popup" @submit.prevent="handleSubmit(onClickCreateCost)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="margin" name="margin" rules="required" v-slot="{ errors }">
                <small class="label">Margin (%)</small>
                <vs-input v-model="form.margin" name="name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <small class="label">Formulation Type</small>
                <v-select name="type" :closeOnSelect="true" v-model="form.formulation_type"
                  :options="['powder', 'liquid', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="!isCreateMode" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="form.note" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-user-type-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const MarginCostRepository = RepositoryFactory.get('margin_cost');
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      margin: '',
      formulation_type: '',
      note: ''
    },
    isCreateMode: true
  }
}

export default {
  name: 'AddNewMarginCostPopUp',
  data() {
    return initialState()
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    async openPopup(id) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchMarginCost()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {
        this.convertAndNotifyError(error.message);
      }
    },
    async fetchMarginCost() {
      await this.$vs.loading({
        container: '#create-margin-cost-popup',
        scale: 0.45
      })
      try {
        const { data } = (await MarginCostRepository.getMarginCost(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-margin-cost-popup > .con-vs-loading')
    },
    async onClickCreateCost() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-margin-cost-popup',
        scale: 0.45
      })
      try {
        this.form.margin = Number(this.form.margin).toFixed(2)
        if (this.isCreateMode) {
          await MarginCostRepository.createMarginCost(this.form);
          this.showSuccessMessage('Margin cost added!');
        } else {
          await MarginCostRepository.updateMarginCost(this.id, this.form);
          this.showSuccessMessage('Margin cost updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-margin-cost-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-margin-cost-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-user-types>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
